export const About = (props) => {
  return (
    <div id="about">
      <div className="container">

        <div className="row display-flex">
          <div className="col-xs-12 col-lg-7">
            <div className="row display-flex">

              <div className="col-xs-12 col-md-12">
                <div className="about-text">
                  <h2>ABOUT US</h2>
                  <p>
                    We bring precision, discipline, and forward-thinking technology together.
                  </p>
                  <div className="bar" />
                </div>
                <p>
                  <b>Akriv Tech</b>{" "}
                  {props.data ? props.data.paragraph : "loading..."}
                </p>
              </div>
              <div className="col-xs-12 col-md-12">
                <p>{props.data ? props.data.paragraph2 : "loading..."}</p>
              </div>
              <div className="col-xs-12 col-md-12">
                <p>
                  Our mission is to{" "}
                  <b>
                    turn bold ideas into reliable, scalable digital solutions
                  </b>
                  . {props.data ? props.data.paragraph3 : "loading..."}
                </p>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-lg-5 about-img">
            <div className="about-img-div">
              <div className="about-img-div-2">
                <div className="about-img-div-3">
                  <div className="about-img-div-4" />
                  <div className="about-img-div-5" />
                  <div className="about-img-div-6" />
                  <div className="about-img-div-7">
                    {/* <span>A</span> */}
                    <img className="img-responsive" src="img/akriv-logo.svg" alt="akriv" />
                  </div>
                  <div className="about-img-div-8">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-6 h-6 text-primary"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
                  </div>
                  <div className="about-img-div-9">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb w-6 h-6 text-primary"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path><path d="M9 18h6"></path><path d="M10 22h4"></path></svg>
                  </div>
                  <div className="about-img-div-10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield w-6 h-6 text-primary"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
                  </div>
                  <div className="about-img-div-11">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-6 w-6 text-primary"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  </div>
                </div>
              </div>
            </div>
            {/* <img
              src="img/about_us.png"
              className="img-responsive"
              alt="aboutUs"
            /> */}
          </div>
        </div>
        <div className="about-core-values">
          <h2>Our Core Values</h2>
          <p>
            The principles that guide everything we do and define who we are.
          </p>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-3">
            <div className="core-value-desc">
              <div className="core-value-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target h-8 w-8 text-primary" data-replit-metadata="client/src/components/Values.tsx:47:16" data-component-name="value.icon"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
              </div>
              <h3>Excellence</h3>
              <p>
                We strive for excellence in everything we do, delivering solutions that exceed expectations.
              </p>
            </div>
          </div>
          <div className="col-xs-12 col-md-3">
            <div className="core-value-desc">
              <div className="core-value-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-8 w-8 text-primary" data-replit-metadata="client/src/components/Values.tsx:47:16" data-component-name="value.icon"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
              </div>
              <h3>Collaboration</h3>
              <p>
                We believe in the power of teamwork, working closely with clients as true partners.
              </p>
            </div>
          </div>
          <div className="col-xs-12 col-md-3">
            <div className="core-value-desc">
              <div className="core-value-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb w-8 h-8 text-primary"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path><path d="M9 18h6"></path><path d="M10 22h4"></path></svg>
              </div>
              <h3>Innovation</h3>
              <p>
                We embrace change and continuously explore new technologies to stay ahead of the curve.
              </p>
            </div>
          </div>
          <div className="col-xs-12 col-md-3">
            <div className="core-value-desc">
              <div className="core-value-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield w-6 h-6 text-primary"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
              </div>
              <h3>Integrity</h3>
              <p>
                We conduct business with honesty and transparency, building trust with every interaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
